const data = [
  {
    name: "Menu",
    path: null,
    children: [
      { name: "Visão Geral", icon: "mdi-home", route: "/home", path: null },
      {
        name: "Minha Conta",
        icon: "mdi-account-cog",
        route: "/minha-conta",
        path: null,
      },
      {
        name: "Administradores",
        icon: "mdi-account",
        route: "/administradores",
        path: null,

      },
      {
        name: "Dentistas",
        icon: "mdi-doctor",
        route: "/dentistas",
        path: null,
      },
      {
        name: "Cargos",
        icon: "mdi-account-group-outline",
        route: "/cargos",
        path: null,
      },
      {
        name: "Pacientes",
        icon: "mdi-account-card",
        route: "/pacientes",
        path: null,
      },
      {
        name: "Convênios",
        icon: "mdi-shield-plus",
        route: "/convenios",
        path: null,
      },
      {
        name: "Odontogramas",
        icon: "mdi-tooth-outline",
        route: "/odontogramas",
        path: null,
      },
      {
        name: "Prescrições",
        icon: "mdi-receipt-text",
        route: "/prescricoes",
        path: null,
      },
      {
        name: "DSD",
        icon: "mdi-tooth",
        route: "/dsd",
        path: null,
      },
      {
        name: "Consultas",
        icon: "mdi-calendar-clock",
        route: "/consultas",
        path: null,
      },
      {
        name: "Calendário",
        icon: "mdi-calendar-month-outline",
        route: "/calendario",
        path: null,
      },
      {
        name: "Exames",
        icon: "mdi-flask-outline",
        route: "/exames",
        path: null,
      },
      {
        name: "Tipos de Exame",
        icon: "mdi-flask-remove-outline",
        route: "/tipos-de-exame",
        path: null,
      },
      {
        name: "Laboratórios",
        icon: "mdi-microscope",
        route: "/laboratorios",
        path: null,
      },
      {
        name: "Alergias",
        icon: "mdi-alert-circle-outline",
        route: "/alergias",
        path: null,
      },
      {
        name: "Procedimentos",
        icon: "mdi-clipboard-list-outline",
        route: "/procedimentos",
        path: null,
      },
      {
        name: "Especialidades",
        icon: "mdi-stethoscope",
        route: "/especialidades",
        path: null,
      },
      {
        name: "Orçamentos",
        icon: "mdi-file-document-outline",
        route: "/orcamentos",
        path: null,
      },
      // {
      //   name: "Serviços",
      //   icon: "mdi-car-wrench",
      //   children: [
      //     { name: "Lançamentos", route: "/lancamentos", path: null },
      //     { name: "Intervalos", route: "/intervalos", path: null },
      //     { name: "Pedágios", route: "/pedagios", path: null },
      //     { name: "Locais", route: "/locais", path: null },
      //     { name: "Feriados", route: "/feriados", path: null },
      //   ],
      // },
      // {
      //   name: "Cliente",
      //   icon: "mdi-account-multiple-outline",
      //   children: [
      //     { name: "Clientes", route: "/clientes", path: null },
      //     { name: "Solicitantes", route: "/solicitantes", path: null },
      //     { name: "Passageiros", route: "/passageiros", path: null },
      //   ],
      // },
      // {
      //   name: "Veículos",
      //   icon: "mdi-car-hatchback",
      //   route: "/veiculos",
      //   path: null,
      // },
      // {
      //   name: "Manutenções",
      //   icon: "mdi-car-wrench",
      //   children: [
      //     { name: "Preventivas", route: "/preventivas", path: null },
      //     { name: "Corretivas", route: "/corretivas", path: null },
      //   ],
      // },
      // { name: "Passageiros", icon: "mdi-chip", route: "/passageiros", path: null },
    ],
  },
];

export default [...data];
